import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { useActivityLogger } from "activity-logger/react";
import { isActivityPathExcluded, normalizeActivityPath } from "./privacy";

const perfNow = (): number =>
  typeof performance !== "undefined" && performance.now ? performance.now() : 0;

/**
 * Records product routes without ever reading search, hash, or window.location.
 * OAuth callbacks are excluded before they enter the activity logger's queue.
 */
export const PrivacySafeRouteTracker = () => {
  const logger = useActivityLogger();
  const location = useLocation();
  const startedAt = useRef<number | null>(null);
  const previousKey = useRef<string | null>(null);

  if (previousKey.current !== location.key) {
    startedAt.current = perfNow();
    previousKey.current = location.key;
  }

  useEffect(() => {
    if (!logger || isActivityPathExcluded(location.pathname)) return;

    const renderedAt = perfNow();
    const frontEndRuntimeMs = Math.max(
      0,
      Math.round(renderedAt - (startedAt.current ?? renderedAt)),
    );
    const endpoint = normalizeActivityPath(location.pathname);

    logger.log({
      endpoint,
      url: endpoint,
      parameters: {},
      frontEndRuntimeMs,
      isAjaxRefresh: false,
    });
  }, [location.key, location.pathname, logger]);

  return null;
};
